<template>
<div class="stage">
  <main>
    <div class="">

      <div class="position-relative">
        <section class="story-banner">
          <stage-banner :title="title"></stage-banner>
        </section>

        <section class="story" id="story">
          <div class="container">

            <div class="story-content">

              <div>
                <b-button v-b-modal.chapterselect variant="light" size="sm" class="mb-3 py-0 px-2">
                  <span class="font-weight-bold">章節選擇</span>
                </b-button>
              </div>

              <!-- 要改的內容 -->
              <npc :npc-id="1" >喂喂喂，你在做什麼啊！你搞錯了，顛覆時空的明明是怪盜！</npc>
              <npc :npc-id="3" right>怪盜？我當然會對付他，但你們也是共犯。</npc>
              <npc :npc-id="0" >什麼？</npc>
              <npc :npc-id="3" right>別裝傻！我很清楚你們的陰謀，你們打算動搖時空吧！</npc>
              <npc :npc-id="1" >沒這回事！我們是想恢復錯亂的時空的！</npc>
              <npc :npc-id="3" right>喔？那為何你們在『證明』賴和的事蹟呢？</npc>
              <npc :npc-id="0" >『證明』？</npc>
              <npc :npc-id="3" right>是啊！明明只是微不足道的小人物，但你們卻覺得那個叫賴和的臺灣人是個重要人物吧？</npc>
              <npc :npc-id="1" >等一下，賴和可是臺灣新文學之父啊！那又不是我們說的！</npc>
              <npc :npc-id="3" right>我管你誰說的，你這種想法本就愚不可及！笑死人，又不是富甲一方，也不是什麼有影響力的官員，不過寫過幾篇不成熟的文章，就敢稱為臺灣新文學之父？就因為有你們相信這種莫名其妙的事，時空才會動盪的！</npc>
              <npc :npc-id="0" >⋯⋯原來如此，在警察先生你所在的時空裡，賴和先生並不是什麼知名人士對吧？</npc>
              <npc :npc-id="1" >什麼？你是說這傢伙是另一個時空的——</npc>
              <npc :npc-id="0" >噓！</npc>
              <npc :npc-id="3" right>正是如此。你不但認為那種路人是臺灣新文學之父，還到處解說⋯⋯我們時間警察可不允許你這樣動搖秩序！</npc>
              <npc :npc-id="1" >你、你是時間警察？</npc>
              <npc :npc-id="0" >我懂了，但我有個疑問，關於賴和先生的事，我說的都是歷史上的事實，既然你是時間警察，應該可以穿越時間去調查看看吧？既然我說的都是真的，你為何要阻止？</npc>
              <npc :npc-id="3" right>是真的又怎樣？</npc>
              <npc :npc-id="0" >⋯⋯什麼？</npc>
              <npc :npc-id="3" right>你真的很蠢耶，事實算什麼？秩序才是最重要的！已經形成的秩序要是在歷史深處被動搖，管他是不是事實，都會瓦解既有的秩序。</npc>
              <npc :npc-id="0" >所以就算賴和先生真的是『臺灣新文學之父』，你也要為了你們的秩序否定他？</npc>
              <npc :npc-id="3" right>啊？哈哈哈哈哈！</npc>
              <npc :npc-id="0" >你笑什麼？</npc>
              <npc :npc-id="3" right>你說他真的是『臺灣新文學之父』？笑死我了，這種後世給的稱號，怎樣都好吧！我說不是就不是！你們這種異端分子就給我乖乖就擒吧！</npc>
              <npc :npc-id="1" >呂善安，該怎麼辦啦？他有槍耶⋯⋯</npc>
              <npc :npc-id="0" >⋯⋯嗯，看來只有乖乖聽話了。</npc>
              <npc :npc-id="3" right>跟我走！</npc>

              <map-link name="彰化警察署" map-id="GWcFq9RRvm4ygEZW8"/>

              <move-to-stage-btn link="前往彰化警察署">前往彰化警察署</move-to-stage-btn>

              <!-- 要改的內容到此 -->

            </div>

          </div>
        </section>
      </div>


      <div class="top-level">
        <top-bottom-button :question="isQuestion"></top-bottom-button>

        <b-modal id="chapterselect" hide-footer title="選擇章節">
          <chapter-select :now-stage="stageId"></chapter-select>
        </b-modal>
      </div>

    </div>
  </main>
</div>
</template>

<script>
// import Cookie from '@/utilities/Cookie.js'
import StageBanner from '@/components/StageBanner.vue'
import TopBottomButton from '@/components/TopBottomButton.vue'
import ChapterSelect from '@/components/ChapterSelect.vue'
import '@/assets/css/stage.css'

export default {
  name: 'Stage5_2',
  components: {
    StageBanner,
    TopBottomButton,
    ChapterSelect,
  },
  props: {},
  data() {
    return {
      title: '第五章 - 2',
      isQuestion: false,
      stageId: 'police',
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {

  }
}
</script>

<style scoped>

</style>
